import React from "react";
import OptImg from "@/components/OptImg";

const LOGO_SRC =
  "https://res.cloudinary.com/dmvui9sur/image/upload/v1753453810/WhatsApp_Image_2025-07-23_at_16.03.06_1_1_uv2osr.png";


const GuestFooter = () => (
  <footer className="bg-white text-black pt-10 pb-4 px-4 md:px-20 w-full border-t border-gray-200">
    <div className="max-w-5xl mx-auto flex flex-col md:flex-row justify-between gap-10 md:gap-24">
      {/* Logo & Address */}
      <div className="flex-1 min-w-[220px] flex flex-col items-start">
        <OptImg
          src={LOGO_SRC}
          maxWidth={300}
          alt="TITAN CONTAINERS Logo"
          className="mb-4 h-12 w-auto"
          style={{ maxWidth: 160 }}
        />
        <div className="text-black text-xl md:text-2xl font-bold mb-2 tracking-tight">
          Head Office
        </div>
        <div className="text-gray-700 text-base md:text-lg leading-relaxed font-light pl-1">
          The Kensington Office Tower<br />
          10th Floor – Unit F<br />
          Boulevard Raya Road No. 1<br />
          Kelapa Gading, North Jakarta 14240
        </div>
      </div>
      {/* Contact Us */}
      <div className="flex-1 min-w-[220px] flex flex-col items-start md:items-start mt-6 md:mt-0">
        <div className="text-black text-xl md:text-2xl font-bold mb-2 tracking-tight">
          Contact Us
        </div>
        <div className="space-y-2 text-base md:text-lg font-light w-full">
          <div>
            <a
              href="tel:+622140644888"
              className="text-black hover:text-blue-700 transition font-medium no-underline"
              style={{ textDecoration: "none" }}
            >
              Phone : (021) 40644888
            </a>
          </div>
          <div>
            <a
              href="fax:+62212450519"
              className="text-black hover:text-blue-700 transition font-medium no-underline"
              style={{ textDecoration: "none" }}
            >
              Fax : (021) 245 0519
            </a>
          </div>
          <div>
            <a
              href="mailto:info@titancontainers.id"
              className="text-black hover:text-blue-700 transition font-medium no-underline"
              style={{ textDecoration: "none" }}
            >
              Email : info@titancontainers.id
            </a>
          </div>
        </div>
      </div>
    </div>


    {/* Copyright */}
    <div className="max-w-5xl mx-auto pt-6 mt-6 border-t border-gray-200 text-gray-500 text-xs text-center font-light">
      &copy; {new Date().getFullYear()} Titan Container. All rights reserved.
    </div>
  </footer>
);

export default GuestFooter;
